import { DialogContent, DialogActions, Button, TextField, DialogContentText, Link, Stack } from '@material-ui/core';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { signIn } from '../../../api_helper/api';
import SnackbarAlertContext from '../../../context/SnackbarAlertContext';

const signInSchema = z.object({
	email: z.string().min(1, 'Email is required'),
	password: z.string().min(1, 'Password is required'),
});

const SignInForm = ({ handleToggleAuthMode, onClose, onSuccess }) => {
	const { register, formState, handleSubmit } = useForm({ resolver: zodResolver(signInSchema), mode: 'all' });

	const snackbarAlertContext = useContext(SnackbarAlertContext);

	const [isLoading, setIsLoading] = useState(false);

	const formSubmitHandler = async (data) => {
		try {
			setIsLoading(true);

			const { email, password } = data;

			const res = await signIn({ email, password });

			if (!res.data.token) {
				throw new Error(res.data.msg);
			}

			onSuccess(res.data);
		} catch (error) {
			snackbarAlertContext.setSnackbarAlert({
				isSnackbarOpen: true,
				autoHide: 3000,
				msg: error.message || 'There was an error signing in. Please try again later.',
				severity: 'error',
			});
		}

		setIsLoading(false);
	};

	return (
		<form onSubmit={handleSubmit(formSubmitHandler)}>
			<DialogContent>
				<Stack sx={{ gap: 2 }}>
					<TextField
						{...register('email')}
						label="Email"
						error={!!formState.errors.email}
						helperText={formState.errors.email?.message}
						disabled={isLoading}
					/>

					<TextField
						{...register('password')}
						label="Password"
						type="password"
						error={!!formState.errors.password}
						helperText={formState.errors.password?.message}
						disabled={isLoading}
					/>

					<DialogContentText>
						Don't have an account?{' '}
						<Link onClick={handleToggleAuthMode} underline="always" style={{ cursor: 'pointer' }}>
							Sign Up
						</Link>
					</DialogContentText>
				</Stack>
			</DialogContent>

			<DialogActions>
				<Button color="primary" onClick={onClose}>
					Cancel
				</Button>
				<Button type="submit" color="primary" variant="contained" disabled={isLoading}>
					Log In
				</Button>
			</DialogActions>
		</form>
	);
};

export default SignInForm;
